import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonGroup, Button, ButtonToolbar } from 'react-bootstrap';

class AutofacturacionListToolbarActions extends Component {
  handleOnToggleSelectableItems = () => {
    this.props.onToggleSelectableItems();
  };

  goToTicketStampingPage = () => {
    this.props.history.push('/ext/receptores/autofacturacion/tickets/facturar');
  };

  render() {
    return (
      <ButtonToolbar
        aria-label="Acciones"
        className="d-inline-flex"
      >
        <ButtonGroup
          className="mr-2"
          aria-label="Nueva factura"
        >
          <Button
            variant="primary"
            onClick={this.goToTicketStampingPage}
          >
            <FontAwesomeIcon icon={['fas', 'plus']} /> Factura
          </Button>
        </ButtonGroup>
        {/* <ButtonGroup aria-label="Acciones secundarias">
          <Button variant="secondary" onClick={ this.handleOnToggleSelectableItems }>
            <FontAwesomeIcon icon={ ['fas', 'check'] } />
          </Button>
        </ButtonGroup> */}
      </ButtonToolbar>
    );
  }
}

export default withRouter(AutofacturacionListToolbarActions);
